import { getCoresPorEspecialidade, CoresEspecialidade } from '@/constants/coresEspecialidades';

export class CoresHelper {
  private static coresAtuais: CoresEspecialidade = getCoresPorEspecialidade();

  static aplicarCoresPorEspecialidade(especialidade?: string): void {
    this.coresAtuais = getCoresPorEspecialidade(especialidade);
    this.aplicarCSSVariaveis();
  }

  static getCoresAtuais(): CoresEspecialidade {
    return this.coresAtuais;
  }

  static getLogoPorEspecialidade(especialidade?: string): string {
    const cores = getCoresPorEspecialidade(especialidade);
    return cores.logo || '/logo-medics-horizontal.jpg';
  }

  static getLogoVerticalPorEspecialidade(especialidade?: string): string {
    const cores = getCoresPorEspecialidade(especialidade);
    return cores.logoVertical || '/logo-medics-vertical.png';
  }

  private static aplicarCSSVariaveis(): void {
    const root = document.documentElement;

    // Aplicar variáveis CSS customizadas
    root.style.setProperty('--especialidade-primary', this.coresAtuais.primary);
    root.style.setProperty('--especialidade-secondary', this.coresAtuais.secondary);
    root.style.setProperty('--especialidade-gradient', this.coresAtuais.gradient);

    // Aplicar classes CSS para compatibilidade
    document.body.className = document.body.className.replace(/especialidade-\w+/g, '');
    document.body.classList.add(`especialidade-${this.coresAtuais.name.toLowerCase().replace(/\s+/g, '-')}`);
  }

  static getClasseEspecialidade(especialidade?: string): string {
    const cores = getCoresPorEspecialidade(especialidade);
    return `especialidade-${cores.name.toLowerCase().replace(/\s+/g, '-')}`;
  }

  static limparEspecialidade(): void {
    document.body.className = document.body.className.replace(/especialidade-\w+/g, '');
    const root = document.documentElement;
    root.style.removeProperty('--especialidade-primary');
    root.style.removeProperty('--especialidade-secondary');
    root.style.removeProperty('--especialidade-gradient');
    root.style.removeProperty('--especialidade-primary-rgb');
  }
}
